import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

export const Container = styled.div`
  display: flex;
`
export const Box = styled.div`
  height: 2.75rem;
  width: 7.625rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &.primary {
    background: ${colors.black1};
    color: white;
  }

  &.secondary {
    background: ${colors.gandalf};
  }

  &.switch__left {
    border-top-left-radius: 4.375rem;
    border-bottom-left-radius: 4.375rem;
  }

  &.switch__right {
    border-top-right-radius: 4.375rem;
    border-bottom-right-radius: 4.375rem;
  }
`
export const Title = styled.h5`
  margin: 0;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: inherit;
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/switch/switch.style.tsx